// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__T9Lqt","cell":"Footer_cell__eLjFO"};